<div class="g-modal-v2 cart-modal">
  <div class="g-modal-v2-header">
    <div class="g-modal-v2-title">
      {{ 'global.cart' | translate }}
    </div>

    <button
      class="g-modal-v2-close"
      (click)="dialogRef.close({ type: 'CANCEL' })"
    >
      <tc-icon name="close" />
    </button>
  </div>

  <div class="g-modal-v2-content cart-modal-content">
    <cart
      [sourceForAnalytics]="data.sourceForAnalytics"
      (continueShopping)="dialogRef.close({ type: 'CANCEL' })"
      (goToCheckout)="dialogRef.close({ type: 'CHECKOUT' })"
    />
  </div>
</div>
